// extracted by css-extract-rspack-plugin
export default {"button":"_facaeb4e","boxy":"_6fcdecf4","rounded":"_f7598bb","circle":"_2f80878a","disabled":"_fe4bffe8","roundedCorners":"_2cb11cef","primaryButton":"_af178582"};